import React from 'react';
import PropTypes from 'prop-types';

const Loader = ({ loaderText, className }) => {
  return (
    <div className={`global-loader ${className}`}>
      <div className="global-loader__container">
        <div className="global-loader__logo">
          <div className="global-loader__loader" />
        </div>
        <div className="global-loader__text">{loaderText}</div>
      </div>
    </div>
  );
};

export default Loader;

Loader.propTypes = {
  className: PropTypes.string,
  loaderText: PropTypes.string,
};
Loader.defaultProps = {
  className: null,
  loaderText: null,
};
